import { Carousel } from 'react-carousel-minimal';
import trip from '../../images/07.jpg'
import './gallery.css'

const Gallery = () => {
    const data = [
        {
          image: "https://i.imgur.com/kjHTTD8.jpg",
          caption: ""
        },
        {
          image: "https://i.imgur.com/T4rYKD3.jpg",
          caption: ""
        },
        {
          image: "https://i.imgur.com/2vNEyGO.jpg",
          caption: ""
        },
        {
          image: "https://i.imgur.com/9kxaZXZ.jpg",
          caption: ""
        },
        {
          image: "https://i.imgur.com/WwGeNQ5.jpg",
          caption: ""
        },
        {
          image: "https://i.imgur.com/Jv7R5Ue.jpg",
          caption: ""
        }
        
      ];
    
      const captionStyle = {
        fontSize: '2em',
        fontWeight: 'bold',
      }
      const slideNumberStyle = {
        fontSize: '20px',
        fontWeight: 'bold',
      }
    return (
    <div id="" className="wrapper">
        <h1 id="Comics" className="title">The Comic</h1>
            <div style={{ textAlign: "center" }}>
        
        <div style={{
          padding: "0 20px"
        }}>

          <Carousel
            data={data}
            time={5000}
            width="100vw"
            height="auto"
            captionStyle={captionStyle}
            radius="10px"
            slideNumber={true}
            slideNumberStyle={slideNumberStyle}
            captionPosition="bottom"
            automatic={false}
            dots={true}
            pauseIconColor="white"
            pauseIconSize="40px"
            slideBackgroundColor="darkgrey"
            slideImageFit="cover"
            thumbnails={false}
            thumbnailWidth="100px"
            style={{
                display:"flex",
                flexDirection:"column",
              textAlign: "center",
              maxWidth: "950px",
              maxHeight: "700px",
              margin: "20px auto",
              justfyContent:"center",
                            
            }}
          />
        </div>
      </div>
      <img src={trip} style={{width:"100vw", bottom:"0"}}/>
    </div>
    )
}

export default Gallery
